import React, { useState } from 'react';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import './Style.css';
import { SelectInput } from '../../../Components';
const Index = () => {
    const [rowPerPage, setRowPerPage] = useState(10);
    return (
        <>
            <div
                style={{
                    overflowY: 'hidden',
                    overflowX: 'auto',

                    boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)',
                    marginTop: '1.5rem',
                    borderRadius: '10px',
                }}
            >
                <table className="invoice_table">
                    <thead className="invoice_table_head">
                        <tr className="invoice_table_head_row">
                            <td className="invoice_table_head_data">Invoice No. #</td>
                            <td className="invoice_table_head_data">Invoice Date</td>
                            <td className="invoice_table_head_data">Invoice Period</td>
                            <td className="invoice_table_head_data">Invoice Amount</td>

                            <td className="invoice_table_head_data">Action</td>
                        </tr>
                    </thead>
                    <tbody className="invoice_table_body">
                        <Component number="NPPL/11084" date="2021-05-03" period="Apr 2021" amount="Rs. 29910.27" />
                        <Component number="NPPL/11084" date="2021-05-03" period="Apr 2021" amount="Rs. 29910.27" />
                        <Component number="NPPL/11084" date="2021-05-03" period="Apr 2021" amount="Rs. 29910.27" />
                        <Component number="NPPL/11084" date="2021-05-03" period="Apr 2021" amount="Rs. 29910.27" />
                        <Component number="NPPL/11084" date="2021-05-03" period="Apr 2021" amount="Rs. 29910.27" />
                        <Component number="NPPL/11084" date="2021-05-03" period="Apr 2021" amount="Rs. 29910.27" />
                        <Component number="NPPL/11084" date="2021-05-03" period="Apr 2021" amount="Rs. 29910.27" />
                        <Component number="NPPL/11084" date="2021-05-03" period="Apr 2021" amount="Rs. 29910.27" />
                        <Component number="NPPL/11084" date="2021-05-03" period="Apr 2021" amount="Rs. 29910.27" />
                        <Component number="NPPL/11084" date="2021-05-03" period="Apr 2021" amount="Rs. 29910.27" />
                    </tbody>
                </table>
            </div>
            <div className="pagination_footer">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <SelectInput
                        marginZero
                        style={{ minWidth: '30px' }}
                        label="Rows per page:"
                        value={rowPerPage}
                        changeHandler={(e) => {
                            setRowPerPage(e.target.value);
                        }}
                        options={[
                            { name: '10', value: 10 },
                            { name: '25', value: 25 },
                            { name: '50', value: 50 },
                        ]}
                    />
                </div>
                <div className="pagination_footer_pageinfo">
                    <p className="page_details">1-10 of 50</p>
                    <div>
                        <ChevronLeftIcon className={`footer_pagination_icon disabled`} />
                        <ChevronRightIcon className={`footer_pagination_icon`} />
                    </div>
                </div>
            </div>
        </>
    );
};

const Component = ({ period, amount, date, number }) => {
    return (
        <tr className="invoice_table_body_row">
            <td className="invoice_table_body_data">{number}</td>
            <td className="invoice_table_body_data">{date}</td>
            <td className="invoice_table_body_data">{period}</td>
            <td className="invoice_table_body_data">{amount}</td>
            <td className="invoice_table_body_data">
                <div className="invoice_table_body_data_action">
                    <p className="invoice_table_body_data_action_blue">CSV</p>
                    <p className="invoice_table_body_data_action_red">PDF</p>
                </div>
            </td>
        </tr>
    );
};
export default Index;
